import { useCallback } from "react";

import { useActivationSetFavicons } from "../../hooks/useActivationSetFavicons";
import { AlertsFeed } from "../AlertsFeed";
import { Virtualized } from "../Virtualized";

import { NewsAlertCard } from "./components/NewsAlertCard";
import { useNewsAlerts } from "./hooks/useNewsAlerts";

export const NewsAlertsFeed = () => {
    const { data = [], isLoading: isAlertsLoading } = useNewsAlerts();
    const { favicons, isLoading: isFaviconsLoading } = useActivationSetFavicons();

    const getItemKey = useCallback((index: number) => data[index].id, [data]);

    return (
        <AlertsFeed
            isLoading={isAlertsLoading || isFaviconsLoading}
            isEmpty={!data.length}
        >
            <Virtualized
                count={data.length}
                getItemKey={getItemKey}
                renderItem={(index) => (
                    <NewsAlertCard
                        alert={data[index]}
                        favicon={favicons?.[data[index].domain] ?? ""}
                    />
                )}
            />
        </AlertsFeed>
    );
};
